import { I18nProvider } from '@lingui/react';

import { ThemeProvider } from '@olist/design-system';
import { UnitedGlobalStyle } from '@olist/united';

import i18n from './helpers/i18n';
import Routes from './routes';

function App() {
  return (
    <ThemeProvider>
      <UnitedGlobalStyle />
      <I18nProvider i18n={i18n}>
        <Routes />
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
